module.exports = __webpack_public_path__ + "img/btw4.e72ac1e0.jpg";